// CustomerReviews.jsx
import React, { useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, EffectCoverflow } from 'swiper/modules';

import styles from './CustomerReviews.module.css';
import { FaStar } from "react-icons/fa"; // Dùng FaStar để fill đầy hơn



const reviews = [
    {
        name: "Lukas M",
        location: "Berlin",
        visits: "4 Besuche",
        text: "Wir sind Japanerin und Berliner. Bei GIRI Restaurant fühlt sich Berlin endlich wie Zuhause an"
    },
    {
        name: "Aya & Matthias",
        location: "Kreuzberg",
        visits: "7 Besuche",
        text: "Wir sind Japanerin und Berliner. Bei GIRI Restaurant fühlt sich Berlin endlich wie Zuhause an. Kenji-san ist Familie."
    },
    {
        name: "Dr. Sarah Klein",
        location: "Charlottenburg",
        visits: "2 Besuche",
        text: "Das beste Tonkotsu-Ramen außerhalb Fukuokas. 22 Stunden Brühe, die mich sprachlos gemacht hat."
    },
    {
        name: "Hiroshi & Lena",
        location: "Prenzlauer Berg",
        visits: "11 Besuche",
        text: "Wir haben bei Jiro Ono gegessen. Trotzdem sitzen wir jeden Freitag wieder bei Kenji-san. Das sagt alles."
    },
    {
        name: "Felix von Richter",
        location: "Mitte",
        visits: "Michelin Scout",
        text: "Eines der fünf besten Omakase außerhalb Japans. Berlin hat gerade einen neuen Stern bekommen."
    },
    {
        name: "Mika Yamamoto",
        location: "Tokyo → Berlin",
        visits: "6 Besuche",
        text: "Ich habe beim Tsukune geweint. Es schmeckt genau wie bei meiner Großmutter in Ebisu. GIRI Restaurant ist Japan."
    }
];
const logo = "/assets/logo/logo.png"; // Logo Smoke Lounge

export default function CustomerReviews() {
    const sectionRef = useRef(null);
    const swiperRef = useRef(null);

    return (
        <section ref={sectionRef} className={styles.section}>
            <div className={styles.container}>
                <Swiper
                    modules={[Navigation, Autoplay,EffectCoverflow]}
                    spaceBetween={50}
                    // slidesPerView={3}
                    effect={'coverflow'}
                    grabCursor={true}
                    breakpoints={{
                        // Khi màn hình >= 320px (Mobile)
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 20
                        },
                        // Khi màn hình >= 1024px (Desktop)
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 50
                        }
                    }}
                    centeredSlides={true}
                    coverflowEffect={{
                        rotate: 50,
                        stretch: 0,
                        depth: 100,
                        modifier: 1,
                        slideShadows: true,
                    }}
                    pagination={true}
                    loop={true}
                    autoplay={{ delay: 8000, disableOnInteraction: false }}
                    speed={1400}
                    fadeEffect={{ crossFade: true }}
                    navigation={{
                        prevEl: '.custom-prev',
                        nextEl: '.custom-next',
                    }}
                    className={styles.swiper}
                    onSwiper={(swiper) => { swiperRef.current = swiper; }}
                    onSlideChange={() => {
                     }}
                >
                    {reviews.map((review, index) => (
                        <SwiperSlide key={index}>
                            <div className={styles.card}>
                                <div className={styles.cardHeader}>
                                    <div className={styles.avatar}>
                                        <img src={logo} alt="GIRI Logo" className={styles.avatarImg}/>
                                    </div>
                                    <div className={styles.userInfo}>
                                        <div className={styles.name}>{review.name}</div>
                                        <div className={styles.location}>{review.location}</div>
                                        <div className={styles.visits}>{review.visits}</div>
                                    </div>
                                </div>
                                
                                <div className={styles.stars}>
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar key={i} className={styles.star} />
                                    ))}
                                </div>
                                
                                <div className={styles.quoteIcon}>"</div>
                                <p className={styles.text}>{review.text}</p>
                                
                                <div className={styles.cardFooter}>
                                    <div className={styles.divider}></div>
                                    <div className={styles.signature}>
                                        <span className={styles.verified}>✓</span> Verified Guest
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <button className={`custom-prev ${styles.navBtn} ${styles.prev}`}>
                    <span>‹</span>
                </button>
                <button className={`custom-next ${styles.navBtn} ${styles.next}`}>
                    <span>›</span>
                </button>
            </div>
        </section>
    );
}